import { PasswordStrength } from "../types/PasswordStrength";

export const passwordStrengthPolicy = (password: string): PasswordStrength => {
  const minLength = 8; //w przyszłości będzie to w konfiguracji
  const isLongEnough = password.length >= minLength;

  const hasBigLetters = testBigLetters(password);
  const hasSpecial = testSpecialChars(password);
  const hasSmallLetters = testSmallLetters(password);
  const hasNumbers = testNumbers(password);

  if (
    isLongEnough &&
    hasBigLetters &&
    hasSpecial &&
    hasSmallLetters &&
    hasNumbers
  ) {
    return PasswordStrength.PowerStrong;
  } else if (
    isLongEnough &&
    ((hasBigLetters && hasSmallLetters) ||
      (hasSpecial && (hasBigLetters || hasSmallLetters)) ||
      (hasNumbers && (hasBigLetters || hasSmallLetters)))
  ) {
    return PasswordStrength.PowerMedium;
  } else if (isLongEnough) {
    return PasswordStrength.PowerWeak;
  } else {
    return PasswordStrength.PowerUnacceptable;
  }
};

const testNumbers = (value: string) => {
  const reg = new RegExp(/\d/);
  return reg.test(value);
};

const testBigLetters = (value: string) => {
  const reg = new RegExp(/[A-Z]/);
  return reg.test(value);
};

const testSpecialChars = (value: string) => {
  const reg = new RegExp(/\W/);
  return reg.test(value);
};

const testSmallLetters = (value: string) => {
  const reg = new RegExp(/[a-z]/);
  return reg.test(value);
};
